import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { MotorsDraftFacade, RouterFacade } from '@classifieds-sell/state';
import { StepIds } from 'libs/motors-ui/src/lib/models/motors-step/motors-step-model';
import { MotorsDescriptionAndPhotosDescriptionSectionComponent } from 'libs/motors-ui/src/lib/sections/motors-description-and-photos-description-section/motors-description-and-photos-description-section.component';
import { MotorsDescriptionAndPhotosPhotoSectionComponent } from 'libs/motors-ui/src/lib/sections/motors-description-and-photos-photo-section/motors-description-and-photos-photo-section.component';
import { MotorsDescriptionAndPhotosVideoSectionComponent } from 'libs/motors-ui/src/lib/sections/motors-description-and-photos-video-section/motors-description-and-photos-video-section.component';
import { MotorsPageBase } from '../../../motors-page-base';

@Component({
    templateUrl: './motors-description-and-photos-page.component.html',
    styleUrls: ['./motors-description-and-photos-page.component.scss']
})
export class BoatsAndMarineDescriptionAndPhotosPageComponent
    extends MotorsPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(MotorsDescriptionAndPhotosDescriptionSectionComponent, {
        read: MotorsDescriptionAndPhotosDescriptionSectionComponent
    })
    motorsDescriptionAndPhotosDescriptionSectionComponent: MotorsDescriptionAndPhotosDescriptionSectionComponent;

    @ViewChild(MotorsDescriptionAndPhotosPhotoSectionComponent, {
        read: MotorsDescriptionAndPhotosPhotoSectionComponent
    })
    motorsDescriptionAndPhotosPhotoSectionComponent: MotorsDescriptionAndPhotosPhotoSectionComponent;

    @ViewChild(MotorsDescriptionAndPhotosVideoSectionComponent, {
        read: MotorsDescriptionAndPhotosVideoSectionComponent
    })
    motorsDescriptionAndPhotosVideoSectionComponent: MotorsDescriptionAndPhotosVideoSectionComponent;

    constructor(draftFacade: MotorsDraftFacade, routerFacade: RouterFacade) {
        super(StepIds.descriptionAndPhotos, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(
            this.motorsDescriptionAndPhotosDescriptionSectionComponent
        );
        super.registerSection(
            this.motorsDescriptionAndPhotosPhotoSectionComponent
        );
        super.registerSection(
            this.motorsDescriptionAndPhotosVideoSectionComponent
        );
    }
}
